import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ── Cache hygiene ─────────────────────────────────────────────────────────────
// Clear stale redux-persist keys left over from previous store configurations.
// Harmless to run on every load — only removes the specific persist keys.
const STALE_PERSIST_KEYS = ['persist:root', 'persist:auth', 'persist:app'];
STALE_PERSIST_KEYS.forEach(key => {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
});

// Clear all SW caches in development so old bundles never get served.
if ('caches' in window) {
  caches.keys().then(names => names.forEach(name => caches.delete(name)));
}
// ─────────────────────────────────────────────────────────────────────────────

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service worker: production only — SW on localhost serves stale cache
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
} else if ('serviceWorker' in navigator) {
  // Unregister any stale SW from previous sessions in development
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(r => r.unregister());
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
